import { render } from "./DateColumn.vue?vue&type=template&id=3875f09f&scoped=true"
import script from "./DateColumn.vue?vue&type=script&lang=js"
export * from "./DateColumn.vue?vue&type=script&lang=js"

import "./DateColumn.vue?vue&type=style&index=0&id=3875f09f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3875f09f"]])

export default __exports__